export const DataGridPresets = (tokens) => ({
    /**
     * @deprecated This preset is not applicable to Lens
     */
    noZebraStripes: {
        componentsProps: { row: {} },
    },
    noHeaderBackground: {
        componentsProps: {
            grid: {
                sx: {
                    "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader:hover": {
                        backgroundColor: tokens.component.table.row.default.backgroundColor.value,
                    },
                },
            },
        },
    },
});
//# sourceMappingURL=dataGrid.js.map